<template>
  <div id="app-main-container">
    <router-view />
    <cookie-law theme="royal"
                :button-text="$t('cookieLawButton')">
      <div slot="message"
           class="standard-font-family">
        {{ $t('cookiesLawMessage') }}
      </div>
    </cookie-law>
  </div>
</template>

<script>
import CookieLaw from 'vue-cookie-law';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';
import store from '@/store';

export default {
  name: 'app',
  components: { CookieLaw },
  metaInfo() {
    return {
      title: this.$i18n.t('meta.page.title'),
      meta: [
        // General
        {
          name: 'description',
          content: this.$i18n.t('meta.page.description')
        },
        {
          name: 'keywords',
          content: this.$i18n.t('meta.page.keywords')
        },
        // Twitter
        {
          property: 'twitter:card',
          content: 'product'
        },
        {
          property: 'twitter:site',
          content: '@parkingManagers'
        },
        {
          property: 'twitter:title',
          content: this.$i18n.t('meta.twitter.title')
        },
        {
          property: 'twitter:description',
          content: this.$i18n.t('meta.twitter.description')
        },
        {
          property: 'twitter:description',
          content: '@wesmartpark'
        },
        {
          property: 'twitter:image',
          content: `${store.state.ogUrlHost}/static/img/social.png`
        },
        {
          property: 'twitter:data1',
          content: '40%'
        },
        {
          property: 'twitter:label1',
          content: this.$i18n.t('meta.twitter.label1')
        },
        {
          property: 'twitter:data2',
          content: '45000'
        },
        {
          property: 'twitter:label2',
          content: this.$i18n.t('meta.twitter.label2')
        },
        {
          property: 'twitter:url',
          content: window.location.href
        },
        // Open graph data
        {
          property: 'og:title',
          content: this.$i18n.t('meta.og.title')
        },
        {
          property: 'og:type',
          content: 'website'
        },
        {
          property: 'og:url',
          content: window.location.href
        },
        {
          property: 'og:image',
          content: `${store.state.ogUrlHost}/static/img/social.png`
        },
        {
          property: 'og:image:width',
          content: '1200'
        },
        {
          property: 'og:image:height',
          content: '900'
        },
        {
          property: 'og:image:type',
          content: 'image/png'
        },
        {
          property: 'og:description',
          content: this.$i18n.t('meta.og.description')
        },
        {
          property: 'og:site_name',
          content: 'parkingManagers'
        }
      ]
    };
  },
  created() {
    EventBus.$on(keys.eventOnInitializeWithLanguage, this.changeLanguage);

    store.commit('UPDATE_COUNTRY_CONSTANTS', {});
  },
  destroyed() {
    EventBus.$off(keys.eventOnInitializeWithLanguage, this.changeLanguage);
  },
  methods: {
    changeLanguage(params) {
      let locale = params.locale;
      let init = params.init;
      this.$i18n.locale = locale;
      store.commit('CHANGE_LANG_SELECTED', { langSelected: locale, init: init });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/App.vue